import React, { PropTypes } from 'react';
import operationTypes, { operationTypeToPresentParticiple } from '../../js/operationTypes';
import OperationFailureMessage from '../common/OperationFailureMessage';
import ImageCreateProgress from './ImageCreateProgress';
import LoaderWithText from '../common/LoaderWithText';

const ImageStatus = React.createClass({
    propTypes: {
        operation: PropTypes.object,
        imageCreationProgress: PropTypes.object
    },
    render: function () {
        const { operation, imageCreationProgress } = this.props;

        return <div>
            {operation &&
                <div>
                    {operation.isFaulted() && <OperationFailureMessage operation={operation} />}
                    {operation.isInProgress() && operation.type === operationTypes.createImage && <ImageCreateProgress imageCreationProgress={imageCreationProgress} />}
                    {operation.isInProgress() && operation.type !== operationTypes.createImage && <LoaderWithText loadingText={operationTypeToPresentParticiple(operation.type)} />}
                </div>}
        </div>;
    }
});

export default ImageStatus;



// WEBPACK FOOTER //
// ./src/components/dashboard/ImageStatus.jsx